import { useCallback, useState } from "react";
import { useLocalStorage } from "usehooks-ts";

import { REVIEW_TYPES } from "features/cdm/constants/reviewTypes";

// The CDM "add review" flow: the dialog open state + pending review type, the
// patient's locally-added CDM reviews, and the handler that adds one and asks
// the caller to open its preview (onReviewAdded).
export const useCdmReview = ({
  patientId,
  onReviewAdded,
  onReviewRemoved,
}) => {
  const [isAddCdmReviewDialogOpen, setIsAddCdmReviewDialogOpen] =
    useState(false);
  const [pendingCdmReviewType, setPendingCdmReviewType] = useState(
    REVIEW_TYPES.CDM_REGISTRATION
  );
  const [temporaryCdm, setTemporaryCdm] = useLocalStorage(
    `kinesin-temporary-cdm-${patientId}`,
    []
  );

  const openCdmReviewDialog = useCallback((reviewType) => {
    setPendingCdmReviewType(reviewType);
    setIsAddCdmReviewDialogOpen(true);
  }, []);

  const addCdmReview = useCallback(
    (data) => {
      setTemporaryCdm((prev) => [...prev, data]);
      onReviewAdded?.(data.id);
    },
    [setTemporaryCdm, onReviewAdded]
  );

  const removeCdmReview = useCallback(
    (reviewId) => {
      setTemporaryCdm((prev) => prev.filter((item) => item.id !== reviewId));
      onReviewRemoved?.();
    },
    [setTemporaryCdm, onReviewRemoved]
  );

  return {
    temporaryCdm,
    isAddCdmReviewDialogOpen,
    setIsAddCdmReviewDialogOpen,
    pendingCdmReviewType,
    openCdmReviewDialog,
    addCdmReview,
    removeCdmReview,
  };
};
